import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { ROUTE_URLS, SHOP_ROUTE_URLS } from '../../../app.routes.names';
import { MetaService } from '../../../../services/meta-service.service';
import { UserDeviceService } from '@ztarmobile/zwp-service-backend';
import { ToastrHelperService } from '@services/toast-helper.service';
import { AppState } from '@app/app.service';

@Component({
  selector: 'app-quick-mdn',
  templateUrl: './quick-mdn.component.html',
  styleUrls: ['../quick-top-up.component.scss']
})

export class QuickMdnComponent implements OnInit {
  public quickTopUpForm: FormGroup;

  constructor(
    public router: Router,
    public toastHelper: ToastrHelperService,
    private formBuilder: FormBuilder,
    private userDeviceService: UserDeviceService,
    private appState: AppState,
    private metaService: MetaService) {

    this.quickTopUpForm = formBuilder.group({
      phoneNumber: ['', Validators.compose([Validators.required, Validators.maxLength(14), Validators.minLength(14)])],
      confirmPhoneNumber: ['', Validators.compose([Validators.required, Validators.maxLength(14), Validators.minLength(14)])],
    }, { validator: [this.matchingPhoneNumber('phoneNumber', 'confirmPhoneNumber'), this.matchingDigits('phoneNumber')] });
  }

  ngOnInit(): void {
    this.metaService.createCanonicalUrl();
  }

  public checkPhoneNumber(): void {
    this.quickTopUpForm.markAllAsTouched();
    if (!!this.quickTopUpForm.valid) {
      const mdn = this.quickTopUpForm.get('phoneNumber').value.replace(/[^a-zA-Z0-9]/g, '');
      this.userDeviceService.checkDeviceNetworkByMdn(mdn).then((result) => {
        this.appState.loading = false;
        if (!!result) {
          const params = [];
          params[SHOP_ROUTE_URLS.PARAMS.MDN] = mdn;
          this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.VOUCHER_QUICK_TOP_UP}`, params]);
        } else {
          this.appState.loading = false;
          this.toastHelper.showWarning('An error has occured! Please try again later');
        }
      }, (error) => this.notCompatibleDevice(error));
    }
  }

  public backHomePage(): void {
    this.router.navigate([ROUTE_URLS.HOME]);
  }

  public onPaste(event: any): void {
    event.preventDefault();
  }

  public matchingDigits(mdn: string): ValidatorFn {
    return (group: FormGroup): ValidationErrors | null => {
      const phoneNumber = group.get(mdn);
      const isMatching = /^\D*(\d)(?:\D*|\1)*$/.test(phoneNumber.value);
      if (isMatching === true) {
        phoneNumber.setErrors({ matchingDigits: true });
        return { matchingDigits: true };
      }
    };
  }

  public notCompatibleDevice(response: any): void {
    const errorMessage = response.message || response;
    console.warn('Device not supported', errorMessage);
    this.toastHelper.showWarning(errorMessage);
    this.appState.loading = false;
  }

  private matchingPhoneNumber(mdn: string, confirmMdn: string): ValidatorFn {
    return (group: FormGroup): ValidationErrors | null => {
      const phoneNumber = group.get(mdn);
      const confirmPhoneNumber = group.get(confirmMdn);

      if (phoneNumber && confirmPhoneNumber && !!phoneNumber?.value && !!confirmPhoneNumber?.value && phoneNumber.value !== confirmPhoneNumber.value) {
        confirmPhoneNumber.setErrors({ mismatchedPhoneNumber: true });
        return { mismatchedPhoneNumber: true };
      }
    };
  }
}